// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blue {
  color: white;
  background-color: #085FFF;
}
.blue:hover {
  color: #E0E0E0;
}

.icon-container {
  height: 100%;
  width: 40px;
  background-color: #085FFF;
  border: unset;
  display: flex;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/app/components/common/languages-picker/languages-picker.component.scss","webpack://./src/styles/global/_colors.scss"],"names":[],"mappings":"AACA;EACI,YAAA;EACA,yBCEc;ADFlB;AAEI;EACE,cCNkB;ADMxB;;AAIE;EACE,YAAA;EACA,WAAA;EACA,yBCRc;EDSd,aAAA;EACA,aAAA;EACA,mBAAA;AADJ","sourcesContent":["@import '../../../../styles/global/colors';\n.blue {\n    color: white;\n    background-color: $interviews-blue;\n\n    &:hover {\n      color: $interviews-light-gray;\n    }\n\n  }\n  .icon-container {\n    height: 100%;\n    width: 40px;\n    background-color: $interviews-blue;\n    border: unset;\n    display: flex;\n    align-items: center;\n  }","$interviews-light-gray: #E0E0E0;\n$interviews-alt-light-gray: #ECECEC;\n$interviews-table-gray: #F5F5F5;\n$interviews-dark-gray: #262624;\n$interviews-gray: #585857;\n$interviews-blue: #085FFF;\n$interviews-scroll-blue: #b4ceff;\n$interviews-pink: #FF7FDE; \n$interviews-btn-submitted: #FADDB3;\n$interviews-btn-submitted-outline: #ED8E00;\n$interviews-btn-approved: #DAF2B7;\n$interviews-btn-approved-outline: #83D510;\n$interviews-btn-rejected: #FBCCD2;\n$interviews-btn-rejected-outline: #ED001C;\n$interviews-btn-draft: rgb(148, 148, 141);\n$interviews-btn-draft-outline: rgb(57, 57, 57);"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
